import React from "react";
import "./statementUploader.css";
import TechnicalErrorIconSvg from "../../helpers/technicalError";
import Footer from "../view/Footer";

const ErrorPopup = ({
  variant = "popup",
  outerStyle,
  iconWidth = "40",
  iconHeight = "40",
  onTryAgain,
  buttonText = "Try Again",
  children,
}) => {
  return (
    <div className={`card-body ${variant}  text-centered  rounded-2`}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          flexDirection: "column",
          alignContent: "stretch",
          flexWrap: "nowrap",
          alignItems: "center",
          ...outerStyle,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "15px",
          }}
        >
          <div>
            <TechnicalErrorIconSvg width={iconWidth} height={iconHeight} />
          </div>
          {children}
          <button className="upload-button" onClick={onTryAgain}>
            {buttonText}
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ErrorPopup;
